// ─── Styles de l'écran Plans & Emplacements (extraits pour alléger) ──
import { StyleSheet } from 'react-native';

export const makeStylesPlans = (UI) => StyleSheet.create({
  page:  { flex: 1, backgroundColor: UI.bg },
  corps: { padding: 16, paddingTop: 12 },
  hIc:   { fontSize: 18, color: UI.accent },
  hIcOn: { opacity: 1 },
  err:    { backgroundColor: UI.dangerTint, borderWidth: 1, borderColor: UI.danger, borderRadius: 10,
            padding: 10, margin: 12, marginBottom: 0 },
  errTxt: { color: UI.danger, fontSize: 12.5, fontWeight: '600' },
  infoB:   { backgroundColor: UI.accentTint, borderWidth: 1, borderColor: UI.accent, borderRadius: 10,
             padding: 10, margin: 12, marginBottom: 0 },
  infoTxt: { color: UI.accent, fontSize: 12.5, fontWeight: '600' },
  sess:        { flexDirection: 'row', alignItems: 'center', gap: 10, backgroundColor: UI.accentTint,
                 borderBottomWidth: 1, borderBottomColor: UI.accent, paddingHorizontal: 14, paddingVertical: 9 },
  sessTxt:     { flex: 1, fontSize: 12.5, color: UI.accent, fontWeight: '700' },
  sessBtn:     { backgroundColor: UI.accent, borderRadius: 8, paddingHorizontal: 12, paddingVertical: 6 },
  sessBtnTxt:  { color: '#fff', fontSize: 12.5, fontWeight: '700' },
  sessAnnul:   { paddingHorizontal: 4, paddingVertical: 6 },
  sessAnnulTxt:{ color: UI.muted, fontSize: 12.5, fontWeight: '600' },
  pointRow:  { flexDirection: 'row', alignItems: 'center', gap: 8, paddingLeft: 26, paddingVertical: 5 },
  pointNom:  { flex: 1, fontSize: 12.5, color: UI.muted },
  point:     { width: 34, height: 30, borderRadius: 8, borderWidth: 1, borderColor: UI.border,
               alignItems: 'center', justifyContent: 'center', backgroundColor: UI.champ },
  pointOk:   { borderColor: UI.accent, backgroundColor: UI.accentTint },
  pointKo:   { borderColor: UI.danger, backgroundColor: UI.dangerTint },
  pointTxt:  { fontSize: 14, color: UI.faint, fontWeight: '800' },
  pointTxtOk:{ color: UI.accent },
  pointTxtKo:{ color: UI.danger },
  fondCentre:  { flex: 1, backgroundColor: UI.overlay, alignItems: 'center', justifyContent: 'center', padding: 26 },
  motif:       { width: '100%', backgroundColor: UI.bg, borderRadius: 16, padding: 18 },
  motifTitre:  { fontSize: 15.5, fontWeight: '800', color: UI.ink, marginBottom: 4 },
  motifBtns:   { flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', gap: 16, marginTop: 16 },
  motifPasser: { fontSize: 13.5, color: UI.muted, fontWeight: '600' },
  motifOk:     { backgroundColor: UI.accent, borderRadius: 9, paddingHorizontal: 14, paddingVertical: 9 },
  motifOkTxt:  { color: '#fff', fontSize: 13.5, fontWeight: '700' },
  seg:      { flexDirection: 'row', borderWidth: 1, borderColor: UI.border, borderRadius: 9, overflow: 'hidden' },
  segBtn:   { paddingHorizontal: 9, paddingVertical: 5 },
  segBtnOn: { backgroundColor: UI.accentTint },
  segTxt:   { fontSize: 14, color: UI.muted },
  segTxtOn: { color: UI.accent },
  crumbs:    { flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', paddingHorizontal: 16, paddingTop: 10 },
  crumbItem: { flexDirection: 'row', alignItems: 'center' },
  crumbSep:  { color: UI.faint, marginHorizontal: 5 },
  crumbTxt:  { fontSize: 12.5, color: UI.accent, fontWeight: '600' },
  crumbCur:  { color: UI.muted },
  editTitre: { fontSize: 13, fontWeight: '800', color: UI.faint, textTransform: 'uppercase',
               letterSpacing: 0.4, marginBottom: 12 },
  ctrl:     { flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', gap: 7, marginBottom: 9 },
  ctrlLbl:  { fontSize: 12.5, color: UI.muted, fontWeight: '600' },
  step:     { width: 28, height: 28, borderRadius: 8, borderWidth: 1, borderColor: UI.border,
              alignItems: 'center', justifyContent: 'center', backgroundColor: UI.champ },
  stepTxt:  { fontSize: 14, color: UI.accent, fontWeight: '700' },
  chip:     { borderWidth: 1, borderColor: UI.border, borderRadius: 9, paddingHorizontal: 10, paddingVertical: 6,
              backgroundColor: UI.card },
  chipOn:   { borderColor: UI.accent, backgroundColor: UI.accentTint },
  chipTxt:  { fontSize: 12.5, color: UI.muted, fontWeight: '600' },
  chipTxtOn:{ color: UI.accent },
  aplacer:      { marginTop: 6 },
  aplacerTitre: { fontSize: 12, fontWeight: '700', color: UI.muted, marginBottom: 7 },
  aplacerWrap:  { flexDirection: 'row', flexWrap: 'wrap', gap: 7 },
  aplacerChip:  { flexDirection: 'row', alignItems: 'center', gap: 6, borderWidth: 1, borderColor: UI.border,
                  borderRadius: 9, paddingHorizontal: 10, paddingVertical: 6, backgroundColor: UI.card, maxWidth: 170 },
  aplacerChipOn:{ borderColor: UI.accent, backgroundColor: UI.accentTint },
  aplacerTxt:   { fontSize: 12.5, color: UI.muted, fontWeight: '600', flexShrink: 1 },
  aplacerTxtOn: { color: UI.accent },
  aide:  { fontSize: 11.5, color: UI.faint, lineHeight: 16, marginTop: 10, textAlign: 'center' },
  ligne:      { flexDirection: 'row', alignItems: 'center', gap: 11, backgroundColor: UI.card,
                borderRadius: 13, borderWidth: 1, borderColor: UI.border, padding: 13 },
  ligneEmoji: { fontSize: 22 },
  ligneNom:   { fontSize: 15, fontWeight: '700', color: UI.ink },
  ligneSous:  { fontSize: 11.5, color: UI.muted, marginTop: 2 },
  chev:       { fontSize: 22, color: UI.faint, fontWeight: '300' },
  contenu:      { marginTop: 14, backgroundColor: UI.card, borderRadius: 13, borderWidth: 1,
                  borderColor: UI.border, padding: 10 },
  contLieu:       { flexDirection: 'row', alignItems: 'center', gap: 8, paddingVertical: 8, paddingHorizontal: 6,
                    borderRadius: 8 },
  contLieuRacine: { backgroundColor: UI.accentTint, marginBottom: 2 },
  contChev:   { fontSize: 12, color: UI.faint, width: 12 },
  contEmoji:  { fontSize: 17 },
  contNom:    { flex: 1, fontSize: 13.5, fontWeight: '700', color: UI.ink },
  contNomRacine: { color: UI.accent, fontSize: 14.5, fontWeight: '800' },
  contBadge:  { fontSize: 12, fontWeight: '800', color: UI.muted, minWidth: 24, textAlign: 'center',
                borderWidth: 1, borderColor: UI.border, borderRadius: 999, paddingHorizontal: 6, paddingVertical: 1 },
  contIc:     { fontSize: 16, color: UI.accent },
  contElem:    { flexDirection: 'row', alignItems: 'center', gap: 8, paddingVertical: 5, paddingHorizontal: 6 },
  contElemNom: { flex: 1, fontSize: 13, color: UI.ink, fontWeight: '600' },
  contElemQte: { fontSize: 13, fontWeight: '800', color: UI.accent },
  contArt:      { flexDirection: 'row', alignItems: 'center', gap: 8, paddingVertical: 4, paddingHorizontal: 6 },
  contArtPhoto: { width: 22, height: 22, borderRadius: 5, backgroundColor: UI.champ },
  contArtNom:   { flex: 1, fontSize: 12.5, color: UI.muted },
  contArtQte:   { fontSize: 12.5, fontWeight: '700', color: UI.muted },
  llArtLieu:    { fontSize: 11, color: UI.accent, fontWeight: '600', marginTop: 1 },
  selBarre: { flexDirection: 'row', alignItems: 'center', gap: 10, backgroundColor: UI.accentTint,
              borderWidth: 1, borderColor: UI.accent, borderRadius: 10, paddingHorizontal: 12, paddingVertical: 9, marginTop: 10 },
  selTxt:   { flex: 1, fontSize: 12.5, color: UI.accent, fontWeight: '700' },
  selAnnul: { fontSize: 12.5, color: UI.muted, fontWeight: '600' },
  contVide:    { fontSize: 11.5, color: UI.faint, paddingVertical: 4, paddingHorizontal: 6 },
  rechRow:   { flexDirection: 'row', alignItems: 'center', gap: 8, backgroundColor: UI.champ, borderRadius: 10,
               paddingHorizontal: 11, paddingVertical: 8, borderWidth: 0.5, borderColor: UI.champBord, marginBottom: 12 },
  rechIc:    { fontSize: 14, color: UI.faint },
  rechInput: { flex: 1, fontSize: 14, color: UI.ink, paddingVertical: 2 },
  mvBtn:     { width: 30, height: 28, borderRadius: 8, alignItems: 'center', justifyContent: 'center' },
  mvBtnOn:   { backgroundColor: UI.accentTint },
  mvIc:      { fontSize: 15 },
  hint:      { fontSize: 11, color: UI.faint, marginTop: 6 },
  resRow:  { flexDirection: 'row', alignItems: 'center', gap: 10, paddingVertical: 8, borderTopWidth: 0.5, borderTopColor: UI.border },
  resNom:  { fontSize: 13.5, fontWeight: '600', color: UI.ink },
  resSous: { fontSize: 11.5, color: UI.faint, marginTop: 1 },
  fond:    { flex: 1, backgroundColor: UI.overlay, justifyContent: 'flex-end' },
  feuille: { height: '82%', backgroundColor: UI.bg, borderTopLeftRadius: 18, borderTopRightRadius: 18, overflow: 'hidden' },
  feuilleCorps: { padding: 16 },
  lbl:    { fontSize: 12, fontWeight: '700', color: UI.muted, marginTop: 12, marginBottom: 7 },
  input:  { backgroundColor: UI.champ, borderRadius: 10, paddingHorizontal: 12, paddingVertical: 11,
            fontSize: 15, color: UI.ink, borderWidth: 0.5, borderColor: UI.champBord },
  parent:   { flexDirection: 'row', alignItems: 'center', backgroundColor: UI.champ, borderRadius: 10,
              borderWidth: 0.5, borderColor: UI.champBord, paddingHorizontal: 12, paddingVertical: 11, marginBottom: 6 },
  parentOn: { borderColor: UI.accent, backgroundColor: UI.accentTint },
  parentTxt:{ flex: 1, fontSize: 13.5, color: UI.ink },
});
